import(/* webpackMode: "eager" */ "/root/repo/src/app/score-check/education/page.tsx");
